import BaseService from './baseService';

import RequestAuthorizationInterceptor from './interceptors/requestAuthorizationInterceptor';
import ResponseSuccessCheckInterceptor from '@/api/interceptors/responseSuccessCheckInterceptor';
import ResponseErrorCheckInterceptor from '@/api/interceptors/responseErrorCheckInterceptor';

class UserService extends BaseService {
	constructor() {
		const baseAPIUrl = process.env.VUE_APP_BASE_API_URL;
		super(baseAPIUrl + '/user');

		this.http.interceptors.request.use(RequestAuthorizationInterceptor);
		this.http.interceptors.response.use(ResponseSuccessCheckInterceptor, ResponseErrorCheckInterceptor);
	}

	async loginWithKeycloak() {
		return super.post(`/login-with-token`);
	}

	async refresh(oldToken: string) {
		return super.post(`/refresh-token`, undefined, {
			headers: {
				'X-Old-Token': oldToken,
			},
		});
	}
}

export default new UserService();
